import { PAGE_TYPE } from '@utils/constants';
import injectorServer from '@src/pages/common/injectorServer';
import { TempAiAlertDiagnostics, TempAppAiAlertDiagnostics } from './temp';

export const AiAlertDiagnostics = injectorServer(
  {},
  { pageType: PAGE_TYPE.TEMP_DASHBOARD },
)(TempAiAlertDiagnostics);

export const AppAiAlertDiagnostics = injectorServer(
  {},
  { pageType: PAGE_TYPE.TEMP_DASHBOARD },
)(TempAppAiAlertDiagnostics);

export { PreAiAlertDiagnostics } from './pre';
export { PreAdAiAlertDiagnostics } from './preAd';
export { PreAppAiAlertDiagnostics } from './preApp';
